import React from "react";
import { observer } from "mobx-react";
import { dataSearchState } from "../state";
import { verifyBulkActionPerformedAndAllow } from "../DataSearchUtils";

const ROWS = [
  { label: "Followers", minKey: "linkedinFollowersMin", maxKey: "linkedinFollowersMax" },
  { label: "Connections", minKey: "linkedinConnectionsMin", maxKey: "linkedinConnectionsMax" }
];

/** "5,000+", "500–1,000", "up to 200"; null when neither bound is set. */
export const audienceRangeText = (min, max) => {
  const lo = Number(min) > 0 ? Number(min) : null;
  const hi = Number(max) > 0 ? Number(max) : null;
  if (lo && hi) return `${lo.toLocaleString()}–${hi.toLocaleString()}`;
  if (lo) return `${lo.toLocaleString()}+`;
  if (hi) return `up to ${hi.toLocaleString()}`;
  return null;
};

/** LinkedIn follower and connection count ranges (either bound optional). */
const LinkedinAudienceInputs = observer(() => {
  const fd = dataSearchState.filterComponentData || {};

  const update = (key, value) => {
    const digits = String(value).replace(/[^\d]/g, "");
    const performAction = () =>
      dataSearchState.setFilterComponentData({
        ...dataSearchState.filterComponentData,
        [key]: digits === "" ? null : Number(digits)
      });
    if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
      verifyBulkActionPerformedAndAllow(performAction);
    } else {
      performAction();
    }
  };

  return (
    <div className="employeesByDeptSection">
      {ROWS.map(({ label, minKey, maxKey }) => {
        const min = fd[minKey];
        const max = fd[maxKey];
        const invalid = min > 0 && max > 0 && min > max;
        return (
          <div className="employeesByDeptCard" key={minKey}>
            <div className="linkedinAudienceLabel">{label}</div>
            <div className="employeesByDeptRangeRow">
              <input
                type="text"
                inputMode="numeric"
                className={`employeesByDeptRangeInput${invalid ? " hasError" : ""}`}
                placeholder="Min"
                value={min ?? ""}
                onChange={e => update(minKey, e.target.value)}
              />
              <span className="employeesByDeptRangeDash">-</span>
              <input
                type="text"
                inputMode="numeric"
                className={`employeesByDeptRangeInput${invalid ? " hasError" : ""}`}
                placeholder="Max"
                value={max ?? ""}
                onChange={e => update(maxKey, e.target.value)}
              />
            </div>
            {invalid && <div className="employeesByDeptRangeError">Min can't be more than max.</div>}
          </div>
        );
      })}
      <p className="linkedinAudienceHint">Leave a box empty for no limit.</p>
    </div>
  );
});

export default LinkedinAudienceInputs;
